import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import SimpleTypeahead from "vue3-simple-typeahead";
import routeJob from "@/router/job";
import routeAdmin from "@/router/index";

import VueNotificationList from "@dafcoe/vue-notification";
import "@/styling/main.css";
import "@dafcoe/vue-notification/dist/vue-notification.css";
import VueSocialSharing from "vue-social-sharing";

import PositionsPreView from "@/features/public/views/PositionsPreView.vue"; // Se till att sökvägen är korrekt

import SetupCalendar from "v-calendar";

import InputText from "@/features/shared/components/form/v2/InputText.vue";

store.dispatch("initializeUserSession");

const host = window.location.host;
const parts = host.split(".");
const domainLength = 3; // route1.example.com => domain length = 3

const listingSubDomains = new Array<string>(
  "jobb",
  "jobb-local",
  "jobb-dev",
  "jobb-staging"
);

const adminSubDomains = new Array<string>(
  "min-dev",
  "min-staging",
  "min",
  "min-temp"
);

const router = () => {
  let routes;
  // Test for commit
  if (
    parts.length === domainLength - 1 ||
    parts[0] === "www" ||
    host.includes("min.localhost")
  ) {
    /* www.ansokningsportal.se
      ansokningsportal.se
    */
    routes = routeAdmin;
  } else if (adminSubDomains.includes(parts[0])) {
    /* min.ansokningsportal.se
      ansokningsportal.se
    */
    routes = routeAdmin;
  } else if (
    listingSubDomains.includes(parts[0]) ||
    (parts.length == domainLength && parts[0] !== "www")
  ) {
    routes = routeJob;
  } else {
    // If you want to do something else just comment the line below
    routes = routeAdmin;
  }

  return routes;
};

const app = createApp(App);
app.component("PositionsPreView", PositionsPreView);

app.config.compilerOptions = {
  isCustomElement: (tagName) => {
    return tagName === "vue-advanced-chat" || tagName === "emoji-picker";
  },
};

app.component("InputText", InputText);

app
  .use(store)
  .use(router())
  .use(VueNotificationList)
  .use(SimpleTypeahead)
  .use(VueSocialSharing)
  .use(SetupCalendar, {})
  .mount("#app");
